import { getLeaderboardTimeframe } from "@/sales-tools/leaderboard/api/getLeaderboardTimeframe";
import { getGamificationApiClient } from "../../home-product/api/api";
import type { Employee, TechSupportMetrics } from "./types";

export const getPerformanceMetrics = async (): Promise<TechSupportMetrics | null> => {
    const { start, end } = getLeaderboardTimeframe();

    const resp = await getGamificationApiClient()
        .get(`v1/performance?start=${start}&end=${end}`, { retry: 0 })
        .json<{ employee: Employee }>();

    return resp.employee.metrics?.techSupport ?? null;
};
